
define('css!ui/class/css/selector',[],function(){});
